import {useConfigurateurStore} from "../stores/configurateur";
import {useGlobalLoaderStore} from "../stores/globalLoader";
import {h} from 'vue';
import {useConfirmModal} from "../composables/useConfirmModal";
import {Modal} from "bootstrap";
import ConfigurateurHelpers from "../utils/configurateurHelpers";
import Logger from "../utils/logger";

const logger = new Logger('directive')

const openConfigurateur = {
    mounted(el, binding, vnode) {
        const store = useConfigurateurStore();
        const storeGlobalLoader = useGlobalLoaderStore();
        const stage = binding.modifiers.stage;
        const circuit = binding.modifiers.circuit;
        const voiture = binding.modifiers.voiture;
        const id = binding.modifiers.id;
        const isBapteme = binding.modifiers.is_bapteme;
        let voitureId = null;
        let circuitId = null;
        // Supporte la transmission d'options additionnelles via binding.value en objet
        const options = (binding.value && typeof binding.value === 'object') ? binding.value : {};
        const explicitExperience = options.experience;
        const isBaptemeOption = (options.is_bapteme !== undefined) ? !!options.is_bapteme : (explicitExperience === 'bapteme' ? true : undefined);
        // Snapshot initial; sera mis à jour via updated() pour refléter la dernière valeur passée depuis le composant
        el.__openConfigurateurOptions = options || {};

        if (voiture) {
            store.setFrom('voiture')
            voitureId = binding.value;
            // Accepte aussi un objet même si le modificateur .id est présent
            if (binding.value && typeof binding.value === 'object') { // Vérifier si value est un objet
                logger.log('🎯 Directive - voitureId détecté dans binding.value:', binding.value.id);
                voitureId = binding.value.id;
            }
        }
        if (circuit) {
            store.setFrom('circuit')
            circuitId = binding.value;
            // Accepte aussi un objet même si le modificateur .id est présent
            if (binding.value && typeof binding.value === 'object') { // Vérifier si value est un objet
                circuitId = binding.value.id;
            }
        }

        // Créer une instance du helper avec tous les paramètres
        const helper = new ConfigurateurHelpers({
            el,
            binding,
            store,
            storeGlobalLoader,
            stage,
            circuit,
            voiture,
            id,
            isBapteme,
            voitureId,
            circuitId
        });

        // Utiliser async pour pouvoir await store.openModal()
        el.addEventListener('click', async () => {
            logger.log('🎯 Directive - Click sur bouton, isBapteme:', isBapteme);

            // Récupérer les options courantes
            let options = helper.getOptions();
            logger.log('🎯 Directive - options at click (before merge):', JSON.stringify(options));

            // Si une date a été sélectionnée dans le datepicker correspondant, la fusionner dans les options
            try {
                const dpType = voiture ? 'voiture' : (circuit ? 'circuit' : null);
                const dpId = voiture ? voitureId : (circuit ? circuitId : null);

                if (dpType && dpId) {
                    const dp = document.querySelector(`.datepicker[data-type="${dpType}"][data-id="${dpId}"]`);
                    if (dp && dp.dataset.selectedDateIso) {
                        // Vérifier si c'est un signal de reset
                        if (dp.dataset.selectedDateIso === 'reset') {
                            logger.log('🎯 Directive - Signal reset détecté, nettoyage du store');
                            // Force reset des données de date dans le store
                            store.setPreselectedDateIso(null);
                            store.setDateMode('cadeau');
                            store.setCircuitDateId(null);
                            store.setCurentMonth(null);
                            store.setCurentDate(null);
                            store.setStepDate('month');
                            // Nettoyer le dataset après traitement
                            delete dp.dataset.selectedDateIso;
                            delete dp.dataset.dateMode;
                            logger.log('🎯 Directive - Reset effectué, configurateur ouvert en mode normal');
                        } else {
                            // Logique normale de pré-sélection de date
                            const pickerOptions = {
                                dateMode: dp.dataset.dateMode || 'choice',
                                selectedDateIso: dp.dataset.selectedDateIso,
                                // circuitDateId peut être absent selon les données chargées
                                circuit_date_id: dp.dataset.circuitDateId ? parseInt(dp.dataset.circuitDateId) : undefined,
                            };
                            options = {...(helper.getOptions() || {}), ...pickerOptions};
                            // Mémoriser pour le clic courant
                            el.__openConfigurateurOptions = options;
                            logger.log('🎯 Directive - merged options with datepicker:', JSON.stringify(options));
                            // Propager immédiatement dans le store pour éviter toute perte avant openModal
                            if (options.selectedDateIso) {
                                store.setPreselectedDateIso(options.selectedDateIso);
                                logger.log('🎯 Directive - store.preselectedDateIso set (early):', store.preselectedDateIso);
                            }
                        }
                    }
                }
            } catch (e) {
                logger.warn('⚠️ Impossible de lire la sélection du datepicker :', e);
            }

            // Permet de forcer l'origine via options.from ('voiture' | 'circuit')
            if (options && typeof options === 'object' && options.from) {
                store.setFrom(options.from);
            }

            // D'abord vérifier s'il y a une configuration existante
            if (helper.isSameConfiguration()) {
                // Configuration identique, continuer directement
                helper.handleExperienceChoice();
                return;
            }

            // Vérifier si un configurateur est déjà en cours avec une voiture et un circuit
            if (store.voiture_id && store.circuit_id) {
                // Afficher le popup de reprise avec gestion d'expérience dans les callbacks
                helper.showResumeConfigPopup();
                return;
            }

            // Pas de configuration existante, gérer directement l'expérience
            helper.handleExperienceChoice();
        });

    },
    updated(el, binding) {
        // Synchroniser la dernière valeur passée à la directive afin que le clic lise des données à jour
        el.__openConfigurateurOptions = (binding.value && typeof binding.value === 'object') ? binding.value : {};
    },
}

export default openConfigurateur;
